import { defineStore } from 'pinia'
import { AxiosError } from 'axios'
import { axiosMain } from '@/axios-setup'
import { Organization, Departments, DepartmentsMap, ChangePasswordReq } from '@/models'

export const useOrganazationStore = defineStore('organization', {
  state: () => ({
    organization: {} as Organization,
    departments: [] as Departments,
    changePasswordRes: {}
  }),
  actions: {
    async getOrganizationAction (orgId: string) {
      try {
        const response = await axiosMain.get<Organization>(`/Org/${orgId}`)
        this.organization = response.data
      } catch (error) {
        const axiosError = error as AxiosError
        console.error(axiosError.message)
      }
    },
    async getDepartmentsAction (orgId: string) {
      try {
        const response = await axiosMain.get<DepartmentsMap>(`/Dep/${orgId}`)
        this.departments = response.data.departments
      } catch (error) {
        const axiosError = error as AxiosError
        console.error(axiosError.message)
      }
    },
    async changePassword (body: ChangePasswordReq) {
      try {
        const response = await axiosMain.put('/Auth', body, {
          transformResponse: [(data) => {
            if (typeof data === 'string') {
              return JSON.parse(data.replace(/^\uFEFF/, ''))
            }
            return data
          }]
        })

        this.changePasswordRes = response.data
      } catch (error) {
        const axiosError = error as AxiosError
        console.error(axiosError.message)
      }
    }
  },
  getters: {
    getOrganization: (state) => state.organization,
    getDepartments: (state) => state.departments,
    getChangePasswordRes: (state) => state.changePasswordRes
  }
})
